<template>
  <div style="max-width: 1420px">
    <div class="flex jc-end m-t-6 row-3">     
      <div class="p-x-3 as-end" v-if="schedules.length">
        <div class="flex schedules-items" :class="{'empty': !Object.keys(currentSchedule).length}">
          <figure 
            v-for="schedule in schedules" 
            :key="schedule.id" 
              @click="currentSchedule = schedule"
              class="schedules-item"
              :class="{'active': currentSchedule.id == schedule.id}">
              <div class="schedules-item__content">
                <div class="p-x-2 schedules-item__text">{{ schedule.title }}</div>
                <!-- <br>{{ schedule.id }} -->
              </div>
          </figure>
        </div>
        <hr class="m-b-0 m-t-2">
      </div>
      <modal :name="`quarters`" :adaptive="true"
        :clickToClose="true"  :width="600">
        <card class="p-x-4 p-y-4">
          <div>
            Выберите четверть для применения расписания
            <div class="flex fd-column row m-x-auto m-t-3">
              <div v-for="(q) in quarters" :key="q.id" class="m-y-1 flex">
                <checkbox v-model="quartersIds" :value="q.id" color="#ffc107">
                  {{quartersNums[q.position-1]}} Четверть 
                </checkbox>
              </div>
            </div>
          </div>
          <div class="add-control ta-center m-t-3">
            <p-button class="p-x-8 py-2" @click.native.prevent="applyItem" :disabled="!quartersIds.length"><span>Применить</span>
            </p-button>
          </div>
        </card>
      </modal>
    </div>
    <div class="m-b-2 row-3 flex jc-between ai-end" style="min-height: 56px;">
      <div class="p-x-3" style="min-width: 250px;">
        <div v-if="item">
          <fg-input
            style="max-width: 300px;"
            class="mb-0"
            type="text"
            name="timetable"
            label="Название"
            v-model="item.title"
          />
        </div>
      </div>
      <div class="p-x-3 flex jc-end">
        <button
          class="btn m-l-2"
          :class="{'active': !Object.keys(currentSchedule).length}"
          @click="newSchedule"
          >
          <div class="p-x-3">+</div>
        </button>
        <button
          v-if="Object.keys(currentSchedule).length"
          class="btn btn-red m-l-2"
          :class="{'active': !Object.keys(currentSchedule).length}"
          @click="deleteItem"
          >
          <div class="p-x-3">Удалить</div>
        </button>
      </div>
    </div>
    <div v-if="!schedules.length && !item">
      <div class="text-x3 m-t-8 ta-center">Шаблонов пока нет</div>
    </div>
    <div v-if="item && item.timetable">
      <timetable-template v-model="item.timetable" @first="first"/>
    </div>
    <div class="save-panel">
      <button v-if="Object.keys(currentSchedule).length && !changed" class="btn btn-info btn-icon mb-3 mr-2" @click="$modal.show('quarters')">
        <span class="ti-save"></span>Применить расписание
      </button>
      <button v-if="Object.keys(currentSchedule).length" class="btn btn-success btn-icon mb-3 mr-2" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
      <button v-else-if="item && item.title" class="btn btn-success btn-icon mb-3 mr-2" @click="createItem" >
        <span class="ti-save"></span>{{ "add" | setText("Добавить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, errorNotify } from "@/plugins/functions";
import { toFormData } from "@/_api/_helper";

export default {
  props: ["id"],
  data: () => ({
    timetable: [],
    quartersIds: [],
    quarters: [],
    changed: null,
    quartersNums: ['I', 'II', 'III', 'IV'],
    currentSchedule: {},
    firstTimtables: [],
    schedules: [],
    itemLink: null,
    item: null,
  }),
  components: {
    "timetable-template": () => import("./TimetableTemplate"),
  },
  watch: {
    'item.timetable'(item){

      // this.firstTimtables = JSON.parse(JSON.stringify(item))
      // if(!this.firstTimtables.length){
        // this.firstTimtables = JSON.parse(JSON.stringify(this.item.timetable))
      // }

      if(item.length < 300)
        return
      // if(!this.firstTimtables.length){
      //   this.firstTimtables = JSON.parse(JSON.stringify(item))
      // }
      console.log(JSON.stringify(this.firstTimtables).length, JSON.stringify(item).length, '11111111')
      // if(shallowEqual(JSON.parse(JSON.stringify(this.firstTimtables)), JSON.parse(JSON.stringify(item)) )){
      if(JSON.stringify(this.firstTimtables) != JSON.stringify(item) ){
        this.changed = true
      }

      // this.changed = true

    },
    async currentSchedule(schle){
      this.firstTimtables = []
      this.changed = null
      if(!Object.keys(schle).length)
        return
      this.itemLink = `${this.$store.state.secApiUrl}/schools/${this.bid}/classes/${this.id}/timetable_templates`;  
      this.item = null
      this.item = await this.cardContent(`${this.itemLink}/${schle.id}`);  
      this.timetable = this.item.timetable
      if(schle.quarters)
        this.quartersIds = schle.quarters.map(el=>{return el.id})
    }
  },
  
  async created() {
    if(!this.$store.state.business.id)
      console.log('None bid', this.$store.state)
    this.bid = this.$store.state.business.id
    this.itemLink = `${this.$store.state.secApiUrl}/schools/${this.bid}/classes/${this.id}/timetable_templates`;
    this.schedules = await this.cardContent(`${this.itemLink}`);
    if(this.schedules.length){ 
      this.currentSchedule = this.schedules[0]
      this.item = await this.cardContent(`${this.itemLink}/${this.currentSchedule.id}`);
    }
    // this.timetable = this.item.timetable
      
    let group = await this.cardContent(`business/groups/${this.id}`);
    this.seasonId =  group.course.pivot.season_id
    this.quartersLink = `${this.$store.state.secApiUrl}/schools/${this.bid}/school_seasons/${this.seasonId}/quarters`;
    this.quarters = await this.cardContent(this.quartersLink);
  },
  mounted(){
    
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    first(template){
      console.log('first', template)
      if(!this.firstTimtables.length)
      this.firstTimtables = template
    },
    newSchedule(){
      this.item = null
      this.currentSchedule = {}
      setTimeout(() => {
        this.item = {
          title: "",
          timetable: [],
          quarters: []
        }
      }, 1);
      // this.item = {
      //   timetable: []
      // }
      
      // this.item.timetable = []
    },
    async applyItem() {
      if(!this.quartersIds.length)
        return
      let form = toFormData({quarters: this.quartersIds})
      this.$modal.hide('quarters')
      let res = await this.$http
        .post(`${this.itemLink}/${this.item.id}/applyTemplate`, form)
        .then(() => {
          this.$notify({
            title: "Успешно",
            message: "Расписание успешно применино",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(async () => {
          this.$loading(false);
          this.schedules = await this.cardContent(`${this.itemLink}`);
          this.currentSchedule = this.schedules.filter(e=>{ return e.id == this.currentSchedule.id})[0]
        });
    },
    async deleteItem() {
      this.$loading(true);
      this.firstTimtables = []
      this.changed = null
      let item = await this.$http
        .delete(`${this.itemLink}/${this.item.id}`)
        .then((d) => {
          this.$notify({
            title: "Успешно",
            message: "Шаблон успешно удалён",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.schedules = this.schedules.filter((e, i)=>{
            return e.id != this.currentSchedule.id
          })
          this.item = null
          this.currentSchedule = {}
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async createItem() {
      this.$loading(true);
      this.firstTimtables = []
      this.changed = null
      var d = {
          title: this.item.title,
          timetable: JSON.stringify(this.item.timetable),
      }
      let item = await this.$http
        .post(`${this.itemLink}`, d)
        .then(({data}) => {
          this.$notify({
            title: "Успешно",
            message: "Шаблон успешно добавлен",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          data.data.quarters = []
          this.currentSchedule = data.data
          this.schedules.push(this.currentSchedule)
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
        // this.currentSchedule = this.schedules.filter(e=>{ return e.id == currentSchedule.id})[0]
        // if(current){
        //   this.schedules = await this.cardContent(`${this.itemLink}`);
        //   this.currentSchedule = this.schedules.filter(e=>{ return e.id == current.id})[0]
        // }
    },
    async updateItem() {
      this.$loading(true);
      this.firstTimtables = []
      this.changed = null
      var d = {
          title: this.item.title,
          timetable: JSON.stringify(this.item.timetable),
          quarters: JSON.stringify(this.quartersIds)
      }
      
      let item = await this.$http
        .put(`${this.itemLink}/${this.item.id}`, d)
        .then(() => {
          this.$notify({
            title: "Успешно",
            message: "Шаблон успешно сохранен",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
        this.schedules = await this.cardContent(`${this.itemLink}`);
        this.currentSchedule = this.schedules.filter(e=>{ return e.id == this.currentSchedule.id})[0]
      if (item && item.id) {
        this.item = item;
      }
    },
  },
};
</script>
<style>
</style>
